module.exports = __webpack_public_path__ + "static/customer-headshot-1@2x-a883b785b43c8d0aeb96c8b83e307b24.jpg";